var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "current-plan-wrapper" }, [
    _vm.currentPlans.length > 0
      ? _c("div", { staticClass: "slide-container" }, [
          _c("div", { staticClass: "slide-content" }, [
            _c(
              "div",
              {
                ref: "slideItems",
                staticClass: "slide-items",
                on: {
                  mouseenter: _vm.pauseAutoSlide,
                  mouseleave: _vm.resumeAutoSlide,
                },
              },
              _vm._l(_vm.currentPlans, function (item) {
                return _c(
                  "div",
                  {
                    key: item.currentPlan._id,
                    staticClass: "current-plan-item slide-item",
                    on: { click: _vm.showPlans },
                  },
                  [
                    _c("div", { staticClass: "current-plan-item-head" }, [
                      _c(
                        "div",
                        { staticClass: "current-plan-item-head-left" },
                        [
                          _c(
                            "div",
                            { staticClass: "current-plan-item-head-left-icon" },
                            [
                              _c("DynamicSvg", {
                                attrs: { name: _vm.getIconName() },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "current-plan-item-head-left-title",
                            },
                            [_vm._v(_vm._s(_vm.getTitle()))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "current-plan-item-head-right" },
                        [
                          _c(
                            "PlanItemButton",
                            { attrs: { "is-selected": "" } },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.$t("billing.purchased")) +
                                  "\n                                "
                              ),
                              _c("div", { staticClass: "material-icons" }, [
                                _vm._v("check"),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "current-plan-item-footer" }, [
                      _c(
                        "div",
                        { staticClass: "current-plan-item-footer-left" },
                        [
                          item.currentPlan.endDate
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "current-plan-item-footer-left-item",
                                },
                                [
                                  _c("TimeoutIcon"),
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.getRemainingDays(item.currentPlan)
                                      ) +
                                      " " +
                                      _vm._s(_vm.$t("tables.day")) +
                                      "\n                            "
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "a-tooltip",
                                { attrs: { placement: "topLeft" } },
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(_vm._s(_vm.$t("billing.autoRenew"))),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "current-plan-item-footer-left-item",
                                    },
                                    [_c("RenewIcon")],
                                    1
                                  ),
                                ],
                                2
                              ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "current-plan-item-footer-right" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "current-plan-item-footer-right-item solid",
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(_vm.periods[item.currentPlan.period]) +
                                  "\n                            "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.getQuantity().total > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "current-plan-item-footer-right-item",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.getQuantity(item).total) +
                                      " " +
                                      _vm._s(_vm.getQuantityText()) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.getQuantity().free > 0
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "current-plan-item-footer-right-item",
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.getQuantity(item).free) +
                                      " " +
                                      _vm._s(_vm.getQuantityText(true)) +
                                      "\n                            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _vm.currentPlans.length > 1
              ? _c("div", { staticClass: "slide-controls" }, [
                  _c("div", { staticClass: "slide-nav" }, [
                    _c(
                      "div",
                      {
                        staticClass: "slide-arrow prev",
                        on: { click: _vm.prevSlide },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("keyboard_arrow_left"),
                        ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "slide-dots" },
                      _vm._l(_vm.currentPlans, function (item, index) {
                        return _c("span", {
                          key: index,
                          staticClass: "dot",
                          class: { active: _vm.currentIndex === index },
                          on: {
                            click: function ($event) {
                              return _vm.goToSlide(index)
                            },
                          },
                        })
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "slide-arrow next",
                        on: { click: _vm.nextSlide },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("keyboard_arrow_right"),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
        ])
      : _c(
          "div",
          { staticClass: "current-plan-item", on: { click: _vm.showPlans } },
          [
            _c("div", { staticClass: "current-plan-item-head" }, [
              _c("div", { staticClass: "current-plan-item-head-left" }, [
                _c(
                  "div",
                  { staticClass: "current-plan-item-head-left-icon" },
                  [_c("DynamicSvg", { attrs: { name: _vm.getIconName() } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "current-plan-item-head-left-title" },
                  [_vm._v(_vm._s(_vm.getTitle()))]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "current-plan-item-head-right" },
                [
                  _c("PlanItemButton", [
                    _vm._v(_vm._s(_vm.$t("billing.buyNow"))),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("a-tooltip", { attrs: { title: _vm.getDescription() } }, [
              _c("div", { staticClass: "current-plan-item-description" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.getDescription()) +
                    "\n            "
                ),
              ]),
            ]),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }